import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Making our irc bot talk",
  "description": "",
  "published": "2012-04-25T00:00:00.000Z",
  "redirect_from": ["/blog/making-our-irc-bot-talk/swizec/4243"],
  "categories": "Artificial intelligence, Facebook, Internet Relay Chat, Markov chain, Time series, Twitter, Uncategorized",
  "hero": "./img/images-irobot1.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`[`}{`18:21:38] `}{`<`}{`HairyFotr> `}{`_`}{`chatty-botko`}{`_`}{` we desire to hear moar of you're infinite wisdom `}{`[`}{`18:21:38] `}{`<`}{`_`}{`chatty-botko`}{`_`}{`> know it broken ? `}{`_`}{`chatty-botko`}{`_`}{` doesn't though gets`}</p>
    </blockquote>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Internet_Relay_Chat",
        "title": "Internet Relay Chat"
      }}>{`IRC`}</a>{` might seem quaint and outdated, but for keeping in touch with a group of friends it beats `}<a parentName="p" {...{
        "href": "http://twitter.com",
        "title": "Twitter"
      }}>{`Twitter`}</a>{`, Facebook and Google+ hands down.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/bd6a9e508875d242ec6cff89c3b39428/b4294/images-irobot1.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "78.02690582959642%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'312\\'%20viewBox=\\'0%200%20400%20312\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20156v156h401V0H0v156M278%2022c-3%200-7%204-6%206%201%200%200%202-2%202l-2%201c0-2-1-2-2-2l-11%202-2-1-2%202c0%201%200%202-2%202-4%200-5%202-1%202a258%20258%200%200110%201c3%200%201%202-2%202l-4%201h-3l-3%202c-1%202-10%204-13%202-4-2-11-2-16%201-3%202-3%202-2%207v7l1%207c0%205%202%208%205%208l3%202c1%202%203-1%204-5%200-4%203-7%205-4v6c-1-1-1%200-1%201l-2%204-1%205%201%2015c0%202-1%203-3%204l-3%202c0%202%205%205%207%205l3%201%201%2013c0%2013%202%2025%207%2042%202%2010%202%2015%200%2011-1-2-9-2-11-1l-3%202%205%202h7l3%201h1c1-1%202%201%204%205%205%208%207%209%2013%2010%203%201%204%200%204-1l-1-1-2-2c-1-2%200-2%206-3%207-2%2013-6%2012-8l-3%202c-3%203-9%203-9%200l2-2c2-1%201-3-3-5s-5-4-1-4c3%200%206%204%206%207%200%201%200%202%201%201l6-1%209-1-2-1-4-2c-2-2-2-2%202-3%202-1%205-2%206-4l4-3c2%200%207-4%206-5h-6c-1-2-1-2%202-6%203-3%203-3%205-2%202%200%203%200%206-3%204-4%204-4%201-4-3%201-2%200%201-3l4-3c3-2%204-2%206-1%201%201%201%201%201-1%201-3%204-2%203%201l1%204v4l-1%203c1%201%201%201%202-1l1-2c2%200%202%202%201%206-2%204-2%204%200%204h1l-6%2012v1l-1%201v2c0%202%200%202-1%201-3-2-3%200-1%203s4%2010%202%207l-3-4c-2-4-5%207-4%2014%201%203%200%2015-1%2017-1%201-7%202-6%200l-2-1c-3%201-3%201-4%206l-1%205v-4l-1-4-5-1c-3%200-3%200-2%203%200%203-1%202-2-2l-2-6-2%201-1%202-1%201-3-8c-4-8-6-9-11-2l-12%2012%202-4%203-6c-1-3-2-3-3%200l-2%202c-2%200-12%205-15%208-4%203-4%204%200%204h4c1%200-8%2011-11%2012l-3%204-3%202c-4%200-7%201-7%202h3c3%200%204%202%202%203l-2%201-9%2013c-11%2013-12%2015-8%2017l3%202%204%201%206%201%204%201%2011%201a535%20535%200%200019%204c0-1%203-1%2020%201%2033%204%2031%203%2042%202l11-2%2030-12c6-3%208-6%206-10-2-3-2-3%201-5%202-3%202-3%201-5-2-3%200-4%203-3%205%201%203-1-2-4s-6-4-9-10c-4-8-4-11-1-10%204%200%207%201%209%203l7%201h6l-5-2-4-2%202-1%201-3%202-2h-2c-2-1-2-2-2-15l1-13c0%201-14%204-15%203-2%200-2%200-2%2013%201%2014%201%2015-4%2011-2-1-2-3-2-13l-1-12-7-1-10-3-4-2%208%2012c2%203%203%207%202%209-2%201-2%200-7-6l-9-14%202-1c2%200%203-3%202-4h3c2%201%204%203%207%203%204%202%204%202%206%200%205-4%205-7%200-10-6-5-13-12-12-14%200-1%203%201%207%206%206%206%207%206%2010%206%208-3%2013-2%2013%201%200%202%202%201%208-1%208-5%2013-10%206-7-2%201-3%201-3-1l-1-1%201-7c2-3-1-10-4-10l-2%201-9%201-10%201h-2c0-3-2-2-4%200l-4%203-5%202-2%201v-3l3-5c2-6%204-8%204-3v1l1-1c0%202%205%202%205%200%200-1%201-1%201%201h4l4-5c6-7%208-21%203-24l-2-1h2c2%200%203%200%202-1l2-2c2%200%206-13%204-14-3-1-1-8%202-8l2-1%202-5%201-7c0-4-1-5-5-5s-5-1-3-2V58l-2-2h-1l-3-1-4-5-3-6%201-2-2%201c-1%201-1%201-4-1l-1-3%206-6-2-4c-4-6-16-5-15%202v2l-5-2c-5-3-6-3-6-5l-2-4h-40m59%2039l-1%203-2-3c-2-3-6-2-8%202l-2%203c-2%202-2%208%200%2011%202%201%203%203%203%205l1%205c0%203%200%203-1%202-2%200-3%201-1%203l1%204c0%205%201%206%204%206%202-1%208-8%208-10%200-3%203%200%204%204%200%206%202%204%203-5V81l1-6c1-9-7-21-10-14m-90%2031l3%203%202%204v3l-1%201c-1%200-2-1-2-3%201-2%200-3-2-3-5-1-5-1-5%201-1%204%200%206%204%206l6%201c3%203%207-2%205-8-1-3-7-6-10-5m35%201v1c-3-1-7%201-8%204s0%207%203%207%204%204%202%206c-1%202%200%203%203%203%202%200%203-1%201-2h1l1-2%202-1%201-1-1-2%203-7c2-1%203-2%202-3s0-1%203-1l4%201-5-2-8-3c-4%200-4%200-4%202m81%2032c-3%209-2%2014%203%2017%204%202%206-7%203-17-2-8-4-8-6%200m-113%2036l2%202c2%202%2027%202%2027%201s-2-2-5-2l-6-1h-18m116%2014l-7%204c-1%202%200%207%202%207%204%200%2015-9%2013-10v-2c0-2%200-2-8%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bd6a9e508875d242ec6cff89c3b39428/ca0a1/images-irobot1.webp 223w", "/static/bd6a9e508875d242ec6cff89c3b39428/75680/images-irobot1.webp 445w", "/static/bd6a9e508875d242ec6cff89c3b39428/e88ff/images-irobot1.webp 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/bd6a9e508875d242ec6cff89c3b39428/853b2/images-irobot1.jpg 223w", "/static/bd6a9e508875d242ec6cff89c3b39428/0a4fe/images-irobot1.jpg 445w", "/static/bd6a9e508875d242ec6cff89c3b39428/b4294/images-irobot1.jpg 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/bd6a9e508875d242ec6cff89c3b39428/b4294/images-irobot1.jpg",
                "alt": "Robot",
                "title": "Robot",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Robot`}</figcaption>{`
  `}</figure></p>
    <p>{`There's a bunch of `}<em parentName="p">{`others`}</em>{` on those things. With IRC there's just us ... and a robot overlord.`}</p>
    <p>{`Mostly `}{`_`}{`_`}{`botko`}{`_`}{`_`}{` makes sure to mention when we repost links and keeps irc logs for us. But as soon as `}<a parentName="p" {...{
        "href": "https://twitter.com/#!/smotko"
      }}>{`@smotko`}</a>{` added random phrases to make keeping us in place more interesting. We wanted more.`}</p>
    <p>{`We wanted our bot to speak.`}</p>
    <p>{`It's been ages since I coded just for fun, so last night I made `}{`_`}{`_`}{`botko`}{`_`}{`_`}{` talk.`}</p>
    <h2 {...{
      "id": "what-to-say"
    }}>{`What to say?`}</h2>
    <blockquote>
      <p parentName="blockquote">{`[`}{`18:03:13] `}{`<`}{`_`}{`chatty-botko`}{`_`}{`> `}{`_`}{`botko`}{`_`}{` probably feels left out `}{`[`}{`18:12:45] `}{`<`}{`_`}{`chatty-botko`}{`_`}{`> auto complete :D whoa! mind = blown`}</p>
    </blockquote>
    <p>{`So how do you make a robot speak?`}</p>
    <p>{`Natural language generation is a `}<em parentName="p">{`huge`}</em>{` field, hell I'm doing `}<a parentName="p" {...{
        "href": "http://swizec.github.com/Le-Thesis/"
      }}>{`my thesis`}</a>{` in that general vicinity. For this project I just wanted to have a little fun, not invent a monster -> `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Markov_chain",
        "title": "Markov chain"
      }}>{`markov chain`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Natural_language_generation",
        "title": "Natural language generation"
      }}>{`text generation`}</a>{`!`}</p>
    <p>{`The way a markov chain text generator works is basically:`}</p>
    <ol>
      <li parentName="ol">{`split a text into words`}</li>
      <li parentName="ol">{`create n-grams (n-length groups of words, I used n=1)`}</li>
      <li parentName="ol">{`create unique hashes of all n-grams`}</li>
      <li parentName="ol">{`map each `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/N-gram",
          "title": "N-gram"
        }}>{`n-gram`}</a>{` to a list of `}<em parentName="li">{`next`}</em>{` n-grams`}</li>
    </ol>
    <p>{`You end up with this sort of data structure.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`{-8818677644356330256: {'next': {-6361492750444014453: 1},
                        'text': ['dobu'],
                        'weight': 1.9},
 -8629397782117610386: {'next': {}, 'text': ['podatkov'], 'weight': 0.9},
 7424044602067048: {'next': {14336086128129331: 0.9, 1480645349370722979: 1},
                    'text': [':D'],
                    'weight': 2.9},
# and so on for quite a while
`}</code></pre>
    <p>{`While this works great for static text, an irc chatroom is a rolling `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Time_series",
        "title": "Time series"
      }}>{`time series`}</a>{` that never really ends. Not only will you soon run out of memory, how do you deal with staying relevant?`}</p>
    <p>{`I had to wait until `}<em parentName="p"><strong parentName="em">{`4:03AM`}</strong></em>{` for the solution to hit me!`}</p>
    <p>{`It doesn't have to be complicated at all - just decay the weights of all `}<em parentName="p">{`next`}</em>{` items whenever you poke an element. And do the same whenever a new text is added to the Corpus.`}</p>
    <p>{`Especially important is to choose the starting point well. The more relevant it is to current discussion, the more chance you have of saying something relevant. So instead of choosing at random, we make a weighted choice here as well.`}</p>
    <p>{`When everything is packaged together, usage becomes pretty simple:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`corpus.add(text) # repeat this a couple of times

# to generate, you just
corpus.rewind()
text = " ".join(take(corpus, 5)) # creates a 5 word text
`}</code></pre>
    <p>{`All the `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/botko/blob/speaking/src/Corpus.py"
      }}>{`code is on github`}</a>{`.`}</p>
    <p>{`Making the data structure iterable like that was especially interesting. Now I can change how the generator works without affecting external code.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`    def __iter__(self):
        return self

    def __setitem__(self, ngram, value):
        key = self.__hash(ngram)
        self.data[key] = value

    # adapted from
    # http://eli.thegreenplace.net/2010/01/22/weighted-random-generation-in-python/
    def __weighted_choice(self, items):
        rnd = random.random() * sum([w for w, k in items])
        for i, item in enumerate(items):
            rnd -= item[0]
            if rnd < 0:
                return item[1]

    def __next(self, ngram):
        item = self.__getitem__(ngram)

        if len(item['next']) == 0:
            raise StopIteration

        return self.data[self.__weighted_choice(zip(item['next'].values(),
                                                    item['next'].keys()))
                         ]['text']

    def next(self):
        if not hasattr(self, 'current_ngram'):
            self.rewind()

        self.current_ngram = self.__next(self.current_ngram)
        return self.current_ngram
`}</code></pre>
    <p>{`Pretty cool right?`}</p>
    <h2 {...{
      "id": "when-to-speak"
    }}>{`When to speak?`}</h2>
    <p>{`Okay, that takes care of generating the text. But when should `}{`_`}{`_`}{`botko`}{`_`}{`_`}{` speak anyway?`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "240px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/71398c2ecd27ce074c9a8ba0c1a71110/09b79/3246-2866792711_027e60dd7e_m.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20150v150h130a1416%201416%200%2000111-2c-16%200-17-1-17-5%200-3%202-5%205-5%203%201%204%203%201%203-2%200-3%200-3%202%201%202%204%202%206%200%200-2%201-2%203-2l3-2c2-2%206-2%207%201%200%202%200%202%202%201h7c2-1%2010%200%2011%201%200%203%200%203%201%201%201-3%204-4%205-2h2c2-3%203%200%201%205l-2%204h9c10%200%2012-1%2010-4-1-2%200-5%202-5%205-2%2015-1%2016%201%202%201%202%201%202-1l3-1h7v5c2%200%201%203-1%203l-2-1h-1c-3%202-14%201-14-2l-1-1-1%202c1%201%200%201-1%202-7%202%203%202%2049%202h51V0H0v150M237%205c-4%204-1%2011%204%209l2-2%203%201c3%202%205%202%206-2%202-5-3-10-7-5h-2c-2-3-5-3-6-1M130%208h-3l-4-1c-3%201-4%205-1%207%202%201%203%201%205-1l2-1c0%202%205%203%207%201%203-4-2-8-6-5m241%2011l1%202v1c-2%202-1%2011%201%2010%207%200%207%200%207-5s0-5-3-5h-3l2-1%203-2h-8m19%201h-2l-2%201-1%205v5h7c7%200%209-2%207-5v-2l1-2c0-2-1-3-5-3l-5%201m-60%202l-3%201v7l-1%207h12V24c1-3-1-3-8-2m-55%207l-1%207v6l5-1c5%200%206-1%205-2V29h-9M145%2083l-11%202c-11%200-13%201-13%204l1%204v10c2%203%204%202%204%200-1-2%203-4%2010-6%204-1%207%201%205%202l5%203%202-4v-2h13l-1-6-3-6c-1-1-9-2-12-1m13%2015c-2%200-3%201-1%203%202%201%201%202-1%202l-3%202h-6c0-2-3%201-3%203%200%203%200%204-1%203-1%200-2-1-2-3s0-2-7-2c-6%200-6%200-6%203l1%202-3-2c-4-3-5-3-4%200v22c-1%202%204%209%207%209l2%201c2%202%206%203%206%202l-2-2c-2-1-3-2-2-3l-1-1c-1%200-3-1-3-3-2-4-2-6-1-6%201%201%202%200%202-1l2-1%202-2%202-3%202-3c0-3%203-5%205-4l5%201c6%201%206%202%200%203l-4%202c0%201%205%202%209%201l5-1c1%202-2%205-7%206l-5%202%202%201h3c-1%202-7%204-8%203l-4-1h-3l2%203%204%202c3%200%203%202%201%204l-2%203-4%206-8%209c-6%209-12%2016-19%2022l-6%205h-7c-9%200-17%203-18%207l1%203%201%203%201%202%204%207c4%2010%205%2011%2010%2010%208%200%2010-1%2015-5l5-2c3%200%208-3%205-3l-1-2%202-1c2%201%207-4%209-8a18543%2018543%200%200116-29c0-2%206-6%2010-7l5-1%206-3c8-5%208-5%2013-6%204-2%205-3%205-5%201-4%200-5-3-4a377%20377%200%20001-2c4-2%205-2%204-6-1-2%200-3%201-4%202-1%202-2%202-4-1-2-4-3-9-2h-2l2-1%203-2%201-2c-1-2-5-2-10%200l-7%203c-2%200-3%201-3%202l-1%201c-1%200-2-2-1-9l-1-9-1-4c0-4%200-5-4-4m202%2028l-22%201-67%204a2638%202638%200%2001-7%2078l-4%201-12%202a207%20207%200%2001-39%203c-4%200-4%200-2-1%203-1%204-4%203-19-1-16-2-16-12-13-11%204-17%209-13%2010l-3%202a919%20919%200%2000-46%2014l-7%202-2%201c-2%200-4%203-3%205s1%202-1%203c-2%200-3%201-3%202l2%201c6-3%2022-4%2047-5a537%20537%200%200021%200l-37%206c-2%202%200%203%204%203l3%201h-13a263%20263%200%2001-18%201l9%201c6%200%208%200%208%202l1%201%201-2c0-3%203-1%204%203l1%203%201-3v-3l2%203c0%202%203%204%203%202l-1-1v-3c1-2%204%200%203%202h1c1-2%201-2%203%202%201%201%201%201%201-1-1-3-1-3%202-3%203%201%204%201%204%203%200%203%202%203%202%200s2-3%202%200c1%202%201%202%201-1s-2-4-9-6c-5-1-5-1-2-1l24-4c6-2%2034-1%2034%201h3c1-2%204-2%2012-2l6%201-5%201c0%202%2022%201%2033-1a870%20870%200%200174-12l12-2c3-1%203-1%205-30a2862%202862%200%20014-51c-1-2-6-3-8-1m-41%2016c-8%202-12%208-12%2018%200%206%200%207-2%209s-3%207-1%2010l3%208c0%205%201%206%205%2010%207%207%209%206%2016-2%206-5%205-6-1-1-6%206-8%207-13%202-5-4-5-5-5-10-1-7%200-16%201-15l1%202c-1%204%201%208%204%208l2%201c0%204%208%203%2010-1l3-2c3-1%204-3%204-8v-2l1%202v5c0%204%200%204%203%200s3-9%201-11-2-2-1-5c4-14-5-22-19-18m9%2013l-4%201h-11l-2%205c0%205%200%205%202%205%203-1%2019-3%2021-2v-6c-1-4-1-4-6-3m-49%2075c-2%200-3%201-3%202-1%203-2%203-3%200%200-3-10-3-11%201%200%203%201%205%203%203%201-1%202-1%202%201h10c2-2%203-2%205%200h14c4%201%207-1%207-3s-4-4-6-4v2c2%200%201%203-1%203l-2-2c-1-4-6-4-6-1-1%203-4%203-5%201%200-3-1-4-4-3m-47%2013c-1%204%200%209%202%209h3c1%201%203%200%204-1s2-2%202%200h6c3%203%206%202%206-2v-3h-11c-9%200-10-1-10-2%200-2-2-3-2-1m32%200h-3c-2%200-2%200-2%204v5h9c1%201%202%201%203-1h1c0%201%203%202%205%201%203%200%202-2%200-2-3-1-3-5%200-4%202%200%202%200%202-2-1-2-4-3-6-1s-2%202-4%200h-5m-32%2017c-1%205%200%208%203%207h4l2-2c1-2%201-2%201%200s8%204%2010%201h2l5%201c3%200%205-2%205-6h-13c-15%200-17-1-17-3%200-3-2-1-2%202m72-2l-3%201-3%201h-10l-10%201h-2c-2-2-8-1-9%202%200%205%205%207%207%203v-2l1%202c1%202%204%202%204-1%200-1%201-1%202%201%202%203%209%202%209-1%201-4%203-1%203%203-1%204%201%204%203-1%202-3%202-3%203-1%202%203%206%202%207-1%201-2%201-2%201%200%200%203%2010%203%2010%200l1-2%201%202%201%202%202%202c1%202%204%203%206%201%202-3%201-9-2-10l-3%201h-3l-3-1c-2%201-3%200-3-1-1-2-1-2-3%200l-2%202-2-2c-2-2-3-2-3-1m56%204c-3%202-3%202-3%200%200-3-7-3-7%201v3l-1-3c-1-2-1-2-8-2-8-1-11%201-8%205%201%202%2023%203%2025%201h2c4%202%208-3%204-6-2-2-2-2-4%201m-135%2011l-1%205c0%205%200%205%203%205l4-1h2l8%201c7-1%207-1%208-3s1-2%201%200l1%202c1%201%203-2%202-5-1-2-2-2-10-2l-11%201-6-3h-1m56%200l-1%205-1%204v-4c0-5-4-6-4-1s1%205%2010%206h9v-3c1-4-1-5-5-5-2%201-3%201-5-1s-3-2-3-1m18%201l-1%206%201%202h12l12%201%201-3%201-2v2c1%203%204%203%204%200%200-2%200-2%201%200s1%202%207%202l7%201v-4c0-5%200-6-3-5a125%20125%200%2001-31%200c-3%202-8%201-10-1-1-1-1-1-1%201m51%200c-1%201-2%202-2%205%201%204%202%205%203%203h2c1%202%205%201%206-1h1c1%203%203%202%203%200l1-2%202%202c0%202%204%203%206%201h1c1%201%202%201%203-1h3c3%203%208%202%2010-1l1-4h-16c0-1-13-1-14%201l-1-1-4-1c-1%201-2%200-2-1%200-2-2-2-3%200m-22%2014c-2%201-2%209-1%2010l2-1h2c1%201%2010%201%2010-1l2-3v-3l-4%201h-3l-3-1c-1%201-2%200-3-1%200-1-1-2-2-1m19%205c0%204%201%207%202%204h22l-2-2v-2l2-2h-8c-2-2-5-1-4%201l-1%202-1-3c0-3-2-4-3-1l-2%202-2-2c-2-3-3-2-3%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/71398c2ecd27ce074c9a8ba0c1a71110/ca0a1/3246-2866792711_027e60dd7e_m.webp 223w", "/static/71398c2ecd27ce074c9a8ba0c1a71110/8ac56/3246-2866792711_027e60dd7e_m.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/71398c2ecd27ce074c9a8ba0c1a71110/853b2/3246-2866792711_027e60dd7e_m.jpg 223w", "/static/71398c2ecd27ce074c9a8ba0c1a71110/09b79/3246-2866792711_027e60dd7e_m.jpg 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/71398c2ecd27ce074c9a8ba0c1a71110/09b79/3246-2866792711_027e60dd7e_m.jpg",
                "alt": "How Should You Act on IRC (Internet Relay Chat...",
                "title": "How Should You Act on IRC (Internet Relay Chat...",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`How Should You Act on IRC (Internet Relay Chat...`}</figcaption>{`
  `}</figure></p>
    <p>{`You certainly don't want the bot to spam everyone. But you don't want him to be completely quiet most of the time. Speaking every X amount of events is simply too predictable and boring ...`}</p>
    <p>{`Ideally you'd want him to speak more when the chatroom is busier and less when it's a bit quiet. When it's been quiet for a long time and it suddenly becomes very busy, that's also a good time to speak.`}</p>
    <p>{`Sort of like a greeting.`}</p>
    <p>{`I ended up using a combination of chat velocity and the rate of chat acceleration change to determine the probability of speaking, which is then still left up to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Randomness",
        "title": "Randomness"
      }}>{`randomness`}</a>{`.`}</p>
    <p>{`Velocity is measured as the ratio between the timespan of the last 10 messages and the timespan of the last 60. This basically measures how densely the messages are coming into the chatroom right now.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`velocity_rate = (now - 10_messages_ago_time)/(now - 60_messages_ago_time)
`}</code></pre>
    <p>{`The rate of acceleration change idea took some time to materialize in my head. The idea is that you want to make it likelier for the bot to speak when there is a sudden flurry of activity and fall back to the `}<em parentName="p">{`velocity_rate`}</em>{` formula when conditions are mostly stable.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`v_i = average_speed_of_last_[0+i : i*5]_messages
a_i = delta_of_two_speeds
accel_rate = a_1/a_2
`}</code></pre>
    <p>{`It looks simple in pseudocode, but I promise it took a fair amount of head banging to come up with that!`}</p>
    <p>{`This part of the `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/botko/blob/speaking/src/chitchat.py"
      }}>{`code is also on github`}</a>{`.`}</p>
    <h2 {...{
      "id": "lovely"
    }}>{`Lovely!`}</h2>
    <p>{`That's pretty much it. Our IRC room now has a bot that entertains everyone with its nonsense and I couldn't make myself go to bed until almost five in the morning.`}</p>
    <p>{`All that's left to do now is tweaking the parameters a bit, perhaps iron out a bug or two.`}</p>
    <p>{`I'm almost tempted to connect this guy to #startups ...`}</p>
    <blockquote>
      <p parentName="blockquote">{`[`}{`18:27:27] wisdom ACTION uses this quote in blogpost because it's starting `}{`[`}{`18:27:43] I almost have to use that ... `}{`[`}{`18:27:44] kul, to da si se spet zacel ful pogovarjat, prej`}</p>
    </blockquote>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bostinno.com/2012/03/06/boston-dynamics-cheetah-breaks-land-speed-record-for-legged-bots-might-have-insatiable-blood-thirst-video/"
        }}>{`Boston Dynamics' Cheetah Breaks Land Speed Record for Legged Bots, Might Have Insatiable Blood Thirst `}{`[`}{`Video`}{`]`}</a>{` (bostinno.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://go.theregister.com/feed/www.theregister.co.uk/2012/04/25/turing_test_prize_bletchley_park/"
        }}>{`Wannabe-human bots face 2012 Turing Test in Turing's old office`}</a>{` (go.theregister.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.gamespot.com/dawnspire-prelude/reviews/dawnspire-prelude-review-6168979/"
        }}>{`Dawnspire: Prelude`}</a>{` (gamespot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.i-programmer.info/bookreviews/65-mathematics/3696-hidden-markov-models-for-time-series.html"
        }}>{`Hidden Markov Models for Time Series`}</a>{` (i-programmer.info)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gumption.typepad.com/blog/2011/06/socialbots-2-artificial-intelligence-social-intelligence-and-twitter.html"
        }}>{`Socialbots 2: Artificial Intelligence, Social Intelligence and Twitter`}</a>{` (gumption.typepad.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://news.cnet.com/8301-27080_3-10452342-245.html?part=rss&subj=news&tag=2547-1_3-0-20"
        }}>{`Beware strangers on IM who won't answer your questions`}</a>{` (news.cnet.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.readwriteweb.com/archives/when_bots_go_mad.php"
        }}>{`When Bots Go Mad`}</a>{` (readwriteweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://afetteredmind.com/2012/04/25/ray-kurzweil-and-the-singularity/"
        }}>{`Ray Kurzweil...and the singularity`}</a>{` (afetteredmind.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hackaday.com/2012/04/25/a-camera-that-describes-a-picture-for-you/"
        }}>{`A camera that describes a picture for you`}</a>{` (hackaday.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=dcc40786-643b-40dc-8f49-6c869a6c7a72",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      